import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEngagementAbTestingScheduleDataResult = objectOf({
  minimum_post_test: number,
  max_post_test: number,
});
